<template>
    <!-- Componente para mostrar el slider de plazos para las cotizaciones -->
    <div
        class="slidecontainer w-full mt-10 relative"
        :class="{                                                                                                                   'opacity-50': disabled                                                                                                                   }"
    >
        <input
            id="rs-input"
            type="range"
            min="12"
            max="72"
            step="12"
            class="slider w-full h-2 sm:h-3 lg:h-4 bg-brown outline-none rounded-md"
            :value="value"
            @input="onInputChange($event)"
            :disabled="disabled"
        >
        <div class="relative">
            <ul class="flex justify-between mt-4 px-3">
                <li
                    v-for="n in 6"
                    :key="n"
                    class="relative flex justify-center"
                >
                    <span class="absolute flex items-center space-x-1 sm:space-x-2">
                        <span>
                            {{ n * 12 }}
                        </span>
                        <img
                            v-show="(n * 12) == value && n !== 6"
                            class="h-2 lg:h-3"
                            :src="`${url}/images/icons/blue_arrows.png`"
                            alt=""
                        >
                    </span>
                </li>
            </ul>
            <!-- <div
                id="rs-value"
                class="mt-1 lg:mt-2 flex items-center relative"
            >
                <p class="mr-2 lg:mr-3 text-sm lg:text-base">{{ value }}</p>
                <img
                    class="h-2 lg:h-3"
                    :src="`${url}/images/icons/blue_arrows.png`"
                    alt=""
                >
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ["value", "disabled"],
    data() {
        return {
            url: $(".url").text(),
        };
    },
    methods: {
        // Función para truncar el valor del slider a 12
        // y emitir el valor para la simulcación de los cotizadores
        onInputChange(e) {
            if (e.target.value < 12) {
                e.target.value = 12;
            } else {
                this.$emit("input", e.target.value);
                // this.changePosition();
            }
        },
        // changePosition() {
        //     this.$nextTick(() => {
        //         let position = this.value / 72;
        //         $("#rs-value").css(
        //             "left",
        //             position.toFixed(2) * ($("#rs-input").width() - 40) + "px"
        //         );
        //     });
        // },
    },
    // mounted() {
    //     this.$eventBus.$on("showReqQuote", () => {
    //         this.changePosition();
    //     });

    //     $(window).resize(() => {
    //         this.changePosition();
    //     });
    // },
};
</script>

<style>
#rs-value {
    width: 30px;
    height: 30px;
}

input[type="range"] {
    -webkit-appearance: none;
    /* Hides the slider so that custom slider can be made */
    width: 100%;
    /* Specific width is required for Firefox. */
}

input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
}

input[type="range"]:focus {
    outline: none;
}

/* Special styling for WebKit/Blink */
input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 0px solid #000000;
    height: 30px;
    width: 30px;
    background: url("/images/icons/car_icon.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

/* All the same stuff for Firefox */
input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    border: 0px solid #000000;
    height: 30px;
    width: 30px;
    background: url("/images/icons/car_icon.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

@media only screen and (min-width: 640px) {
    #rs-value {
        width: 35px;
        height: 35px;
    }

    input[type="range"]::-webkit-slider-thumb {
        width: 35px;
        height: 35px;
    }

    input[type="range"]::-moz-range-thumb {
        width: 35px;
        height: 35px;
    }
}

@media only screen and (min-width: 1024px) {
    #rs-value {
        width: 40px;
        height: 40px;
    }

    input[type="range"]::-webkit-slider-thumb {
        width: 40px;
        height: 40px;
    }

    input[type="range"]::-moz-range-thumb {
        width: 40px;
        height: 40px;
    }
}
</style>